export default __webpack_public_path__ + "static/media/MHRD.e8f6b81b.jpg";